export const firebaseConfig = {
	apiKey: 'AIzaSyAl-Jw8mK0CQhwAlIb1F4xxyXw_DqZY8Lo',
	authDomain: 'the-keystudy.firebaseapp.com',
	projectId: 'the-keystudy',
	storageBucket: 'the-keystudy.firebasestorage.app',
	messagingSenderId: '543848649917',
	appId: '1:543848649917:web:673bec33ce27e7df4a13d4',
	measurementId: 'G-7GT3TT5DQ4',
};

export const prodFirebaseConfig = {
	apiKey: 'AIzaSyAuZFtNvSyybVCs_mTnsog8AkvZ4eWma9E',
	authDomain: 'the-keystudy.firebaseapp.com',
	projectId: 'the-keystudy',
	storageBucket: 'the-keystudy.firebasestorage.app',
	messagingSenderId: '543848649917',
	appId: '1:543848649917:web:3059c4c6402ed1394a13d4',
	measurementId: 'G-6ZGBHCLMJC',
};

export const vapidKey =
	'BBSy6yNs-VWcNFRI7HOovjbMVIy7CqQrVaNn6Cr2xn78pV405SIMWvfNLkkEuFtctIWqmWZkqn08mfePm2UAMe0';
